import styled from 'styled-components'
import {scrollVerticalSharedStyle} from "#app/interface/scroll";

export const Chart = styled.div`
  & tspan {
    pointer-events: none;
  }
`

export const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  margin: 15px 0 5px 0;
  
  ${props => props.flex && `
    flex: 1;
  `}
`
export const Explanation = styled.h1`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  color: #7B7B7B;
  margin-bottom: 5px;
`

export const ImgContainer = styled.div`
  overflow-x: auto;
  
  ${scrollVerticalSharedStyle}
`